import React from "react";

const Button = ({
  btnType = "save",
  btnText,
  disabled = false,

  handleOnClick,
  selected = false,
}) => {
  return (
    <button
      disabled={disabled}
      className={`
        w-full ${
          btnType === "save"
            ? ` ${
                selected ? "bg-blue-600" : " bg-submitButton"
              } hover:bg-blue-600 active:bg-blue-700 ${
                disabled &&
                "cursor-not-allowed hover:bg-submitButton active:bg-submitButton "
              }`
            : " bg-red-500 hover:bg-red-600 active:bg-red-700"
        } text-white font-bold py-2 px-4 rounded-lg shadow-lg transition-all duration-300 ease-in-out ${
          disabled && "opacity-70 cursor-not-allowed"
        }
        `}
      onClick={() => handleOnClick()}
    >
      {btnText}
    </button>
  );
};

export default Button;
